(function (ws) {
    'use strict';
    ws.models.reqRevisionPage = Backbone.Model.extend({

        defaults: {
            comment: 'this is comment',
            currentVersion: 0,
            versionID: 0,
            code: '',
            type: ''
        },

        urlRoot: globals.path.api.westcon.selfServiceSubmit
    });
})(westcon);
